import { installGlobalErrorHandlers } from './globalHandlers';
import { initSentry, type PortalApp } from './sentry';

/** Call once at SPA entry (before React render). */
export function bootstrapObservability(app: PortalApp): void {
  initSentry({ app });
  installGlobalErrorHandlers();
}
